import { Route } from "@angular/router";

export function referenceRoute(path: any, service: any): Route {
  return {
    path,
    loadComponent: () => import('./reference-page/reference-page.component').then(c => c.ReferencePageComponent),
    data: {service}
  };
}
